export default {
	message_compose_placeholder: 'Write your message...',
	message_empty_caption: 'Write the first message below',
	message_empty_title: 'No messages yet',
	message_has_multiple_receivers: 'has multiple recipients',
	message_pick_receivers: 'Choose recipients',
	message_receivers: 'Message receiver',
	message_receivers_count: '{count} recipients',
	message_receivers_deselect_all: 'Deselect all',
	message_receivers_done: 'Done',
	message_receivers_group_member_count: '{n} person | {n} people',
	message_receivers_section_groups: 'Groups',
	message_receivers_section_people: 'People',
	message_receivers_section_selected: 'Selected',
	message_remove_receiver: 'Remove {name}',
	message_send_and_memorize_label: 'Send & memorize',
	message_send_label: 'Send',
	message_show_all_receivers: 'Show all recipients',
	message_time_label: "o'clock",
};
